<template comment="方便ui调整">
  <div class="global-search-input">
    <comp-svg class="search-icon" size="13px" fill="#616D7C" name="search"></comp-svg>
    <el-input
      v-model="localValue"
      :placeholder="placeholder"
      clearable
      size="default"
      @change="handleChange"
      @input="handleFilter"
    />
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { Lang } from '@/lang/lang';
import { debounce } from 'lodash-es';


const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: Lang.tips.plzInput,
  },
});

const emit = defineEmits(['update:modelValue', 'change']);

const localValue = ref(props.modelValue);

watch(
  () => props.modelValue,
  (newVal) => {
    localValue.value = newVal;
  }
);

// 防抖处理输入事件
const handleFilter = debounce((value) => {
  emit('update:modelValue', value);
  emit('change', value);
}, 300);

function handleChange(value) {
  emit('update:modelValue', value);
  emit('change', value);
}
</script>

<style scoped>

</style>